module.exports = __webpack_public_path__ + "static/media/ic_video_off_screen.9be989bd.webp";